import React from 'react';
import {useIntl} from 'react-intl';
import {useHistory} from 'react-router-dom';
import messages from '../../../res/translations/messages';
import SurveyCloneModal from './SurveyCloneModal';
import * as api from '../../services/api';

const SurveyCloneButton = ({item, children, disabled, ...rest}) => {
    const [isOpen, setOpen] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const toggle = React.useCallback(() => setOpen(!isOpen), [isOpen]);
    const history = useHistory();
    const handleSubmit = React.useCallback(async (values) => {
        setSubmitting(true);
        try {
            const {data} = await api.cloneSurvey(item.id, values);
            setOpen(false);
            setTimeout(() => history.push(`/surveys/${data.id}/edit`), 0);
        } finally {
            setSubmitting(false);
        }
    }, [item.id, history]);
    const intl = useIntl();
    const initialValues = {
        name: intl.formatMessage(messages.surveys.modals.cloneSurvey.newName, {name: item.name}),
        settings: true,
        variables: true,
    };
    return (
        <>
            {disabled ?
                <a className="disabled">{children}</a> : <a onClick={toggle} {...rest}>{children}</a>}
            <SurveyCloneModal initialValues={initialValues} isOpen={isOpen} toggle={toggle} onSubmit={handleSubmit} submitting={submitting} />
        </>
    );
};

export default SurveyCloneButton;
